var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomePageBackgroundRightBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 484,
    height: 551,
    fill: "none",
    viewBox: "0 0 484 551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A26ECB",
    d: "M307.037 692.471c58.049-21.315 61.793-101.995 5.968-128.595a69.83 69.83 0 0 1-37.229-44.287l-15.03-53.906c-20.381-73.1-81.75-127.443-156.779-138.83l-147.37-22.366a119.54 119.54 0 0 1-26.98-7.406c-94.829-38.446-190.989 52.26-158.137 149.171l76.005 224.214c31.523 92.992 133.474 141.741 225.645 107.896l233.907-85.891Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8C0CF0",
    d: "M320.135 752c58.049-21.315 61.793-101.995 5.967-128.594a69.833 69.833 0 0 1-37.228-44.287l-15.03-53.907c-20.381-73.1-81.751-127.443-156.78-138.83l-152.53-23.149a75.251 75.251 0 0 1-16.981-4.661c-70.345-28.52-133.871 53.241-88.852 114.356l60.118 81.612a103.884 103.884 0 0 1 19.951 69.383l-3.112 41.485c-8.228 109.681 99.669 191.174 202.917 153.261L320.135 752Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 596.273,
    height: 585.382,
    x: -156.375,
    y: 352.718,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 74,
    dy: 110
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_2_356"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomePageBackgroundRightBottom);
export default __webpack_public_path__ + "static/media/welcome_page_background_right_bottom.5377d89c4cde22cc36bcaf5e6f1c2777.svg";
export { ForwardRef as ReactComponent };